var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"actions-block-recover"},[_c('div',{staticClass:"actions-block-recover__button",on:{"click":function($event){$event.stopPropagation();return _vm.restore.apply(null, arguments)}}},[_c('r-icon',{attrs:{"fill":"rocky","icon":"update"}}),_c('span',{staticClass:"ml-2 sulguni rocky--text"},[_vm._v(" Восстановить ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }